"use client";

import React from "react";
import useCMS from "@/utils/hooks/useCMS";
import { parseHTML } from "@/utils/helper";

const AboutUsPage = () => {
  const { cmsData } = useCMS("CONTENTS");

  if (!cmsData?.ABOUT) return null;

  return <div className="container mx-auto space-y-8 p-4 py-10">{parseHTML(cmsData.ABOUT)}</div>;

  // return (
  //   <section className="container mx-auto space-y-8 p-4 py-10">
  //     <div className="flex flex-col items-center gap-4 md:flex-row">
  //       <div className="mb-2">
  //         <h1 className="mb-10 text-2xl font-bold text-primary-base md:text-3xl">
  //           About LGU - Talibon OVR
  //         </h1>
  //         <p className="text-sm font-normal leading-6 text-dark-4">
  //           Welcome to LGU - Talibon E-Services, your convenient online solution for the E-Services
  //           of Talibon LGU. We understand that navigating through traffic violations and compliance
  //           procedures can be a hassle. That&apos;s why we&apos;ve developed a user-friendly
  //           platform to streamline the process and make it easier for you to fulfill your
  //           obligations efficiently and conveniently.
  //         </p>
  //       </div>
  //       <div className="h-full  w-full min-w-[300px] content-center lg:min-w-[500px]">
  //         <img alt="Devices" width={600} height={600} src="/images/landing/about-devices.svg" />
  //       </div>
  //     </div>

  //     <div className="mb-10">
  //       <h1 className="mb-6 text-xl font-bold text-primary-base">Designed for Talibon Citizens</h1>
  //       <p className="text-sm font-normal leading-6 text-dark-4">
  //         Our platform is designed with the citizens of Talibon in mind, aiming to simplify the
  //         processes for your local government&apos;s services. With LGU - Talibon E-Services Portal,
  //         you can pay for your miscellaneous fees, apply, renew and transfer your transport
  //         franchise and other more—all from the comfort of your own home or on the go.
  //       </p>
  //     </div>

  //     <div className="mb-10">
  //       <h1 className="mb-6 text-xl font-bold text-primary-base">Key Features</h1>
  //       <ul className="list-disc text-sm font-normal leading-loose text-dark-4">
  //         <li className="ml-6">
  //           <span className="font-semibold">Accessible Anytime, Anywhere:</span> Say goodbye to long
  //           queues and inconvenient office hours. LGU - Talibon OVR is accessible 24/7, allowing you
  //           to settle your violations at your convenience.
  //         </li>
  //         <li className="ml-6">
  //           <span className="font-semibold">User-Friendly Interface:</span> Our intuitive interface
  //           ensures a seamless experience for users of all levels of technological proficiency.
  //           Whether you&apos;re a digital native or new to online transactions, navigating our
  //           platform is a breeze.
  //         </li>
  //         <li className="ml-6">
  //           <span className="font-semibold">Secure Payment Processing:</span> With our integrated
  //           Payment Gateway, rest assured that your payment transactions are secure with our robust
  //           encryption protocols, safeguarding your sensitive information.
  //         </li>
  //         <li className="ml-6">
  //           <span className="font-semibold">Transparent Record Access:</span> Easily access and
  //           review your violation records, including citation details and payment history, providing
  //           full transparency and accountability.
  //         </li>
  //         <li className="ml-6">
  //           <span className="font-semibold">Instant Confirmation: </span>
  //           Receive instant confirmation of your payment, eliminating uncertainties and ensuring
  //           peace of mind.
  //         </li>
  //       </ul>
  //     </div>

  //     <div className="mb-10">
  //       <h1 className="mb-6 text-xl font-bold text-primary-base">
  //         Where convenience meets compliance
  //       </h1>
  //       <p className="text-sm font-normal leading-6 text-dark-4">
  //         At LGU - Talibon E-Services Portal, we are committed to leveraging technology to simplify
  //         civic engagement and promote compliance with local regulations. Join us in building a more
  //         connected and law-abiding community, one online transaction at a time!
  //         <br />
  //         <br />
  //         For any inquiries or assistance, please don&apos;t hesitate to contact our dedicated
  //         support team. Thank you for choosing LGU - Talibon E-Services Portal for your ordinance
  //         violation settlement needs.
  //       </p>
  //     </div>
  //   </section>
  // );
};

export default AboutUsPage;
